import React from 'react';
import { avatarMap } from '../constants/avatar-map';

export function createNewResultsFactory (setupData) {
	return {
		testSuite: setupData.meta.activeTest,
		finishedOn: 0,
		currentStep: "game-intro",
		saveState: {
			players: mapPlayers(setupData)
		}
	};
}

function mapPlayers (setupData) {
	const players = {};

	for (const player of Object.entries(setupData.players)) {
		players[player[0]] = {
			resources: 25000,
			rewards: []
		}
	}

	return players;
}

export function findActiveStepIndex (resultsData, setupData) {
	const activeStepId = resultsData.currentStep;
	const activeTestSuite = resultsData.testSuite;
	const testSuitData = setupData.testSuites[activeTestSuite];
	const allSteps = testSuitData ? testSuitData.steps : null;
	let activeStep = {};

	if (allSteps) {
		allSteps.find((item, index) => {
			if (item.id === activeStepId) {
				activeStep = {
					step: item,
					index: index
				}
			}
		});

		return activeStep.index;
	}
}

export function buildAvatar ({ avatarOptions }, keepClass = true) {
	let avatar = null;
	let selectedOptionsSorted = Array.isArray(avatarOptions) ? buildCleanAvatarOptions(avatarOptions) : [];

	if (selectedOptionsSorted.length > 1) {
		let avatarInnerHTML = '';

		for (let optionId of selectedOptionsSorted) {
			if (!optionId.includes("glasses")) {
				avatarInnerHTML += avatarMap[optionId];
			}
		}

		const hasWithoutGlassesOption = selectedOptionsSorted
			.findIndex((option) => option.includes("-without-glasses")) !== -1;

		if (!hasWithoutGlassesOption) {
			for (let optionId of selectedOptionsSorted) {
				if (optionId.includes("glasses")) {
					avatarInnerHTML += avatarMap[optionId];
				}
			}
		}

		avatar = <svg version="1.1"
									xmlns="http://www.w3.org/2000/svg"
									x="0px"
									y="0px"
									viewBox="0 0 1000 1000"
									enableBackground="new 0 0 1000 1000"
									xmlSpace="preserve"
									className={keepClass ? 'player__progress__logo': 'eco-score-tracker__player-img'}
									dangerouslySetInnerHTML={{ __html: avatarInnerHTML }} />
	}

	return avatar;
}

// NOTE: the options gets messy only in testing
// so just to make sure the options will always be clean in case there's a back button.
export function buildCleanAvatarOptions(currentOptions) {
	let outfit = "";
	// select/show only the last outfit
	let options = currentOptions.filter((option) => {
		const isOutfit = option.includes("outfit");
		if (isOutfit) {
			outfit = option;
		}
		return !isOutfit;
	});

	if (outfit) {
		options.push(outfit)
	}

	// make sure all options are unique
	options = Array.from(new Set(options));

	// makes debugging easier, and also fixes the z-index (render order) issue on the avatar.
	options = options.sort();

	return options;
}

/**
 * @description
 * Adds the confetti
 *
 */
export function initConfetti () {
	const settings = {
		"target": "confetti",
		"max": "50",
		"size": "1",
		"animate": true,
		"props": ["circle", "square", "triangle", "line"],
		"colors": [[165, 104, 246], [230, 61, 135], [0, 199, 228], [253, 214, 126]],
		"clock": "25"
	}
	let confetti = new window.ConfettiGenerator(settings);
	confetti.render();
}

export function redirectToNeon(url) {
	window.location.href = url ? url : process.env.LOGIN_URI;
}
